export class TransferSchoolAou {
  id: number;
  studentId: number;
  studentCode: string;
  fullName: string;
  yearOfBirth: string;
  gender: string;
  typeOfDisabilityName: string;
  levelName: string;
  /* Thon tin co so tiep nhan */
  eatosId: number;
  provinceId: number;
  districtId: number;
  transferToEatosId: number;
  /**Thong tin chuyen */
  transferDate: Date;
  transferReason: string;
}

export class TransferSchool {
  id: number;
  studentId: number;
  studentCode: string;
  fullName: string;
  yearOfBirth: string;
  gender: string;
  typeOfDisabilityName: string;
  levelName: string;
  /* Thon tin co so tiep nhan */
  eatosId: number;
  provinceId: number;
  districtId: number;
  transferToEatosId: number;
  /**Thong tin chuyen */
  transferDate: Date;
  transferReason: string;
  tranferType: number;
}


export class TransferSchoolTn {
  id: number;
  studentId: number;
  studentCode: string;
  fullName: string;
  yearOfBirth: string;
  gender: string;
  typeOfDisabilityName: string;
  levelName: string;
  /* Thon tin co so tiep nhan */
  eatosId: number;
  provinceId: number;
  districtId: number;
  transferToEatosId: number;
  /**Thong tin chuyen */
  transferDate: Date;
  transferReason: string;
  educationAndTrainingName: string;
  provinceName: string;
  districtName: string;
}
